<app-base-notification [base]="base">
  <div [innerHTML]="'notifications.billing_plan_was_deactivated.text' | customLocale :
  {'reason_for_deactivation': ('subscription-plans.reason-for-deactivation.' + params.reason_for_deactivation | customLocale)}">
  </div>
</app-base-notification>
